import { CAL_BOOK_20MIN_URL } from "../../../config/links";
import styles from "./CustomCtaTile.module.css";

export const CustomCtaTile = (): JSX.Element => (
  <a
    className={styles.tile}
    href={CAL_BOOK_20MIN_URL}
    target="_blank"
    rel="noreferrer noopener"
    aria-label="Book a call to design a bespoke agent"
  >
    <span className={styles.plus} aria-hidden>
      +
    </span>
    <h3 className={styles.title}>Need something custom?</h3>
    <p className={styles.subtitle}>
      Book a 20-min call. We'll design and ship a bespoke agent.
    </p>
    <span className={styles.cta}>
      Book a call
      <span className={styles.arrow} aria-hidden>
        →
      </span>
    </span>
  </a>
);
